export default __webpack_public_path__ + "static/media/Step-05.57fcc0fb.jpg";